import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { NavigationHelper, NavigationHelperConfig } from '~shared/services/navigation-helper.service';
import { FilterOptionsUtil } from '~app/modules/catalog/utils';
import { FilterHandlerParams } from '~app/modules/filters/models/filter-handler-params';

@Injectable({
  providedIn: 'root'
})
export class FilterRouteService {

  constructor(
    private router: Router,
    private navigationHelper: NavigationHelper,
  ) {}

  public applyFilters(filters: FilterHandlerParams) {
    const { params, config } = filters;
    if (params && params.filter) {
      if (params.filter.options) {
        params.filter.options = FilterOptionsUtil.formatFilterOptions(params.filter.options);
      }

      if (params.filter.categories) {
        params.filter.categories = FilterOptionsUtil.formatFilterOptions(
          { options: params.filter.categories }
        ).options;
      }

      if (params.filter.categoryIds) {
        params.filter.categoryIds = FilterOptionsUtil.formatFilterOptions(
          { options: params.filter.categoryIds }
        ).options;
      }
    }

    this.updateRouterState(params, config);
  }

  private updateRouterState(params?: Params, config?: NavigationHelperConfig) {
    const path = this.getCurrentPath();
    this.navigationHelper.replaceUrl([path], { queryParams: params }, config);
  }

  private getCurrentPath() {
    return this.router.url.split('?')[0].slice(1);
  }
}
